import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/Toolbar": Toolbar, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/material/Menu": Menu, "@mui/icons-material/Menu": MenuIcon, "@mui/material/Container": Container, "@mui/material/Avatar": Avatar, "@mui/material/Button": Button, "@mui/material/Tooltip": Tooltip, "@mui/material/MenuItem": MenuItem, "@mui/icons-material/Adb": AdbIcon } } });
export default ClientProvider;
